import {tripActions} from 'data/resources/trips'
import {fulfilled} from 'lib/promiseMiddlewareHelpers'
import _ from 'lodash'

/*
If you want some help creating an action to help insert some records from extras in a different api call that v3 resources don't know about, in to the v3 resources store, this method is for you!
- extras is a list of the format [{type: 'trip', trip: {...}}, ...]
- records is a mapping like {trip: Trip, route: Route, ...} for all things you are looking for
*/
export const spoofV3ResourceExtras = (extras, recordWhitelist) => {
  const records = recordWhitelist.reduce((map, record) => {
    map[_.snakeCase(record.modelName)] = record
    return map
  }, {})

  return {
    type: fulfilled(tripActions.list.type), // This is hardcoded to a type that exists 100%
    payload: {
      extras: extras && extras.map((r) => ({
        type: r.type,
        [r.type]: _.has(records, r.type) && records[r.type].deserialize(r[r.type])
      }))
    },
    meta: {apiv3source: 'trip'} // since we only pass in stuff through extras, to be parse passively, we can pick any record name here.
  }
}
